export default "__VITE_ASSET__DSesML2H__"